export default function mainMenu () {
    const hamburger = document.querySelector('#hamburger');
    const toggleBtn = document.querySelectorAll('.toggle-submenu');
    const body = document.body;
    let btn = null;
    let parentLi = null;

    function animateIn () {
        body.classList.add('menu-open');
        hamburger.classList.add('active');
    }

    function animateOut () {
        body.classList.remove('menu-open');
        hamburger.classList.remove('active');
    }

    function checkState (e) {
        e.preventDefault();
        body.classList.contains('menu-open') ? animateOut() : animateIn();
    }

    function toggleSubMenu (el) {
        btn = el.target;
        parentLi = $(btn).closest('li');
        parentLi.find('.sub-menu').slideToggle(300);
        parentLi.toggleClass('submenu-open');
    }

    if (typeof (hamburger) !== 'undefined' && hamburger !== null) {
        hamburger.addEventListener('click', checkState, false);
    }

    if (typeof (toggleBtn) !== 'undefined' && toggleBtn !== null) {
        for (let i = 0; i < toggleBtn.length; i++) {
            toggleBtn[i].addEventListener('click', toggleSubMenu.bind(this));
        }
    }
}
